import { coreApi } from '../../api'

interface CrmLeadResponse {
  data: [
    {
      id: string
    },
  ]
}

const fetchData = async (customerId: string) => {
  const { data: response } = await coreApi.get<CrmLeadResponse>(
    `/crm/customers/${customerId}/leads/auto-refinancing`,
  )

  return response.data
}

export { fetchData }
